export const UI_CLASS_PREFIX: string = 'ui';
